import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { globalize } from "../translate";
import { MOON_ICON, SUN_ICON } from "../utils/svgs_new";
import { AppIcon } from "./Generic/AppIcon";

export const VisitTimeRange: React.FC<{
  startDateTime: LocalDateTime;
  endDateTime: LocalDateTime;
}> = ({ startDateTime, endDateTime }) => {
  const startsAtDaylight = startDateTime.hour() >= 6 && startDateTime.hour() < 18;

  return (
    <div className="AssignedItemCard__TimeRanges">
      <div className="AssignedItemCard__TimeRange">
        <div className="AssignedItemCard__TimeRangeIcon">
          {startsAtDaylight ? (
            <AppIcon icon={SUN_ICON} size={16} fill="#FFB932" />
          ) : (
            <AppIcon icon={MOON_ICON} size={16} fill="#283847" />
          )}
        </div>

        <div className="AssignedItemCard__TimeRangeText">
          {globalize().formatLocalDateTime(startDateTime, { time: "short" })}
        </div>
      </div>

      <span> - </span>

      <div className="AssignedItemCard__TimeRange">
        <div className="AssignedItemCard__TimeRangeText">
          {globalize().formatLocalDateTime(endDateTime, { time: "short" })}
        </div>
      </div>
    </div>
  );
};
